import { useEffect, useContext } from 'react';

import { SocketContext } from '../context';

const usePublishFailed = (onPublishFailed) => {
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    const executeOnPublishFailed = ({ meetingId }) => {
      onPublishFailed(meetingId);
    };

    socket.on('publishFailed', executeOnPublishFailed);

    return () => {
      socket.removeListener('publishFailed', executeOnPublishFailed);
    };
  }, [onPublishFailed, socket]);
};

export default usePublishFailed;
